module.exports = __webpack_public_path__ + "static/media/Riven_720p.1958170a.mp4";